export class Global {
  //  baseUrl = 'http://localhost:8093';
  //  baseUrl = 'http://13.245.32.27:8093';
  //  baseUrl = 'http://10.250.20.190:8093';
  //  baseUrl = 'http://10.250.20.42:8093';
  // baseUrl = 'http://10.250.20.215:8093';
  // baseUrl = 'http://196.214.41.14:8093';
  //  baseUrl = 'http://auth.nyaradzo.co.za:8093';
  baseUrl = 'https://receipting.nyaradzo.sahwi.net';
  // baseUrl = "https://pepeta.nyaradzo.sahwi.net"

  // PROD AWS
  //  baseUrl = 'http://172.31.16.158:8093'

  //Test AWS
  //  baseUrl = 'http://172.31.9.195:8093'
}
